import React from 'react';
import Icon from '../../components/icons';
import Button from '../../components/elements/button';
import Layout from '../../components/layout';
import Header from '../../components/header';

import { useNavigate } from 'react-router-dom';

const Settings: React.FC = () => {
    const navigate = useNavigate();

    const sageButtons = [
        { label: 'Sage Connector', path: 'sage-connector' },
        { label: 'Sage Master Data Sync', path: 'sage-master-data-sync' },
        { label: 'Asset Group Master', path: 'sage-asset-group-master' },
        { label: 'Sage Assets Mapping', path: 'sage-assets-mapping' },
        /* { label: 'Sage Assets Inventory Mapping', path: 'sage-assets-inventory-mapping' }, */
        { label: 'Sage Other Mapping', path: 'sage-other-mapping' },
        { label: 'Sage Assets Expenses Mapping', path: 'sage-assets-expenses-mapping' },
    ];

    const userButtons = [
        { label: 'Facility Manager', path: 'master-facility' },
        { label: 'Service Tech', path: 'master-service-tech' },
        { label: 'Grower', path: 'master-grower' },
        
    ];

    const billComButtons = [
        { label: 'Bill.com Connector', path: 'bill-com-connector' },
        { label: 'Bill.com Master Data Sync', path: 'bill-com-master-data-sync' },
        { label: 'Bill.com Department Mapping', path: 'master-department' },
    ];

    return (
        <Layout>
            <Header title="Settings" />
            <div className="p-4">
                {/* Sage Intacct Section */}
                <h2 className="text-lg font-semibold mb-3">Sage Intacct</h2>
                <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-3 mb-6">
                    {sageButtons.map((btn, idx) => (
                        <Button
                            key={idx}
                            className="w-full flex items-center rounded border border-gray-300 px-4 py-3 text-sm text-[#804c3c] bg-white hover:bg-gray-100"
                            onClick={() => navigate(`/settings/${btn.path}`)}
                        >
                            <span className="flex-1 text-[#804c3c]">{btn.label}</span>
                            <span className="ml-auto">
                                <Icon name="arrow-right" size={1.4} className="text-[#804c3c]" />
                            </span>
                        </Button>
                    ))}
                </div>

                {/* Bill.com Section */}
                <h2 className="text-lg font-semibold mb-3">Bill.com</h2>
                <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-3 mb-6">
                    {billComButtons.map((btn, idx) => (
                        <Button
                            key={idx}
                            className="w-full flex items-center rounded border border-gray-300 px-4 py-3 text-sm text-[#804c3c] bg-white hover:bg-gray-100"
                            onClick={() => navigate(`/settings/${btn.path}`)}
                        >
                            <span className="flex-1 text-[#804c3c]">{btn.label}</span>
                            <span className="ml-auto">
                                <Icon name="arrow-right" size={1.4} className="text-[#804c3c]" />
                            </span>
                        </Button>
                    ))}
                </div>

                {/* Master Section */}
                <h2 className="text-lg font-semibold mb-3">Master Data</h2>
                <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-3 mb-6">
                    {userButtons.map((btn, idx) => (
                        <Button
                            key={idx}
                            className="w-full flex items-center rounded border border-gray-300 px-4 py-3 text-sm text-[#804c3c] bg-white hover:bg-gray-100"
                            onClick={() => navigate(`/settings/${btn.path}`)}
                        >
                            <span className="flex-1 text-[#804c3c]">{btn.label}</span>
                            <span className="ml-auto">
                                <Icon name="arrow-right" size={1.4} className="text-[#804c3c]" />
                            </span>
                        </Button>
                    ))}
                </div>
            </div>
        </Layout>
    );
};

export default Settings;
